define.alias("shared/utils/hex-to-rgb", "media/utils/hex-to-rgb");